var Engage = (function () {

    // Private methods
    /**
        Setup the Default Toastr Options
    */
    function SetUpToastr() {

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "8000",
            "extendedTimeOut": "8000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut",
            "newestOnTop": true,
            "tapToDismiss": true,
            "preventDuplicates": false,
            "progressBar": true
        };
    }

    /**
     * Apply the current cookie culture code to the body for language targeted css
     */
    function BodyLanguage() {
        $('body').addClass(getCookie('_culture'));
    }

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    // Public methods
    return {
        /**
            Run any required inital setup like setting toastr default options.
        */
        Init: function () {
            SetUpToastr();
            BodyLanguage();
        },
        /**
            Handeling notifications in Engage.
        */
        Notify: {
            /**
                Display an informational message
                @param {string} message The message to display
                @param {string} [title=""] The title of the message.
            */
            Info: function (message, title) {
                title = (typeof title == "undefined") ? "" : title;

                // If title is an empty string then no title is shown.
                toastr.info(message, title);
            },
            /**
                Display a success message
                @param message {string} The message to display
                @param [title=""] {string} The title of the message.
            */
            Success: function (message, title, onHidden) {
                title = (typeof title == "undefined") ? "" : title;

                toastr.options.onHidden = onHidden;

                // If title is an empty string then no title is shown.
                toastr.success(message, title);
            },
            Error: function (message, title) {
                title = (typeof title == "undefined") ? "" : title;

                toastr.error(message, title);
            },
            Clear: function () {
                toastr.clear();
            },
            /**
                Prompt user for a single input.
                @param options {object} Sweet alerts options object.
                @param onSubmit {callback} The function called when the user clicks ok.
            */
            Prompt: function (options, onSubmit) {
                var settings = $.extend({
                    title: "An input!",
                    text: "Write something interesting:",
                    type: "input",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    animation: "slide-from-top",
                    inputPlaceholder: "Write something"
                }, options);

                swal(settings, onSubmit);
            },
            Confirm: function (options, onSubmit) {
                var settings = $.extend({
                    title: "Are you sure?",
                    text: "You will not be able reverse this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes!",
                    cancelButtonText: "No!",
                    closeOnConfirm: false,
                    closeOnCancel: true
                }, options);

                swal(settings, onSubmit);
                //function (isConfirm) {
                //    if (isConfirm) {
                //        swal("Deleted!", "Your imaginary file has been deleted.", "success");
                //    } else {
                //        swal("Cancelled", "Your imaginary file is safe :)", "error");
                //    }
                //};
            }
        }
    }
})();

// Run the init function.
Engage.Init();